export default __webpack_public_path__ + "static/media/image.commercial-technologies-plus.d152ac48.png";